import React, { useEffect } from 'react'
import event10 from './eventImg/event-24.webp'


const Event5 = () => {
    useEffect(() => {
        document.title = "A Half Day Workshop on Acoustics & Indoor Environmental Quality"
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>24 May 2025</h1> 
<h3 className='text-center'>Acoustics & Indoor Acoustics & Indoor Environmental Quality"</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event10} alt='Environmental Quality Acoustics & Indoor Environmental Quality"'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/erPfQ5wkdyE=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}
 
export default Event5

